import React, { useEffect, useState } from "react";
import { Upload } from "lucide-react";
import { Button, ButtonVariant, Text } from "@merge-api/merge-javascript-shared";
import ConfigurationSettingsCard from "../helpers/ConfigurationSettingsCard";
import useCustomizationContext from "../context/useCustomizationContext";
import LogoUploadModal from "../modals/LogoUploadModal";

const ConfigurationBrandingLogoCard = () => {
  const { logo } = useCustomizationContext();

  // STATE
  const [savedLogo, setSavedLogo] = useState<string | File | null>();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [logoUrl, setLogoUrl] = useState<string | undefined>();

  // HOOKS
  useEffect(() => {
    setSavedLogo(logo); // logo can be a string (URL) or a File
  }, [logo]);

  // Generate object URL if savedLogo is a File
  useEffect(() => {
    if (savedLogo instanceof File) {
      const objectUrl = URL.createObjectURL(savedLogo);
      setLogoUrl(objectUrl);
      return () => {
        URL.revokeObjectURL(objectUrl);
      };
    } else if (typeof savedLogo === "string") {
      setLogoUrl(savedLogo);
      return;
    } else {
      setLogoUrl(undefined);
      return;
    }
  }, [savedLogo]);

  return (
    <ConfigurationSettingsCard title="Logo upload">
      <div className="flex flex-row justify-between items-center">
        <Text>Upload a square logo with a white background</Text>
        <div className="flex flex-row gap-4">
          {savedLogo && <img className="rounded-md" width={40} height={40} src={logoUrl} />}
          <Button variant={ButtonVariant.TertiaryWhite} onClick={() => setIsModalOpen(true)}>
            <Upload className="mr-2" size={16} />
            {savedLogo ? "Reupload" : "Upload"}
          </Button>
          <LogoUploadModal isModalOpen={isModalOpen} onHide={() => setIsModalOpen(false)} />
        </div>
      </div>
    </ConfigurationSettingsCard>
  );
};

export default ConfigurationBrandingLogoCard;
